import { useEffect, useRef } from 'react';

export const useTransitionFocus = <T extends HTMLElement>(
  transitionKey: string | number | undefined,
) => {
  const targetRef = useRef<T>(null);
  const baseline = useRef<string | number | undefined>(undefined);

  useEffect(() => {
    if (transitionKey === undefined) return;

    if (baseline.current === undefined) {
      baseline.current = transitionKey;
      return;
    }

    if (baseline.current === transitionKey) return;

    baseline.current = transitionKey;
    targetRef.current?.focus();
  }, [transitionKey]);

  return { targetRef };
};
